import { Flex, Text } from '@chakra-ui/react';
import { useSubmissionContextData } from '../../../contexts/SubmissionContextProvider';
import ICMJEDisclosureSubmittingAuthorOnly from './ICMJEDisclosureSubmittingAuthorOnly';
import ICMJEDisclosureSubmittingAurhoForAll from './ICMJEDisclosureSubmittingAurhoForAll';
import { isFormConfigured } from '../../../utils/formConfig';

const ICMJEDisclosureTab = () => {
  const { submissionContext } = useSubmissionContextData();
  const type = submissionContext?.config?.authorICMJEModel;

  if (!isFormConfigured(type)) {
    return (
      <Flex flexDirection="column" gap={8}>
        <Text>No form available at the moment</Text>
      </Flex>
    );
  }

  return (
    <Flex flexDirection="column" gap={8}>
      {type === 'SubmittingAuthorOnly' ? (
        <ICMJEDisclosureSubmittingAuthorOnly />
      ) : null}
      {type === 'SubmittingAuthorForAll' ? (
        <ICMJEDisclosureSubmittingAurhoForAll />
      ) : null}
    </Flex>
  );
};

export default ICMJEDisclosureTab;
